import { atom } from "jotai";
import { atomWithStorage, RESET } from 'jotai/utils'
import type { TokenListResponse } from "@/lib/types/api";

// NOTE: This global store is only used for redundancy
// It is more simple than writing a react context
// Only use the atom if useMagicBlockPrice is being used in the component tree.
// Otherwise, it will never return a value.
export const messageHistoryAtom = atom({});
export const lastMessageAtom = atom();

// True when an error or 404 page is being displayed
export const isErrorPageAtom = atom(false);

export const freePassAtom = atomWithStorage(
    'cfl:free_pass',
    {
        isActive: false,
        isDialogClosed: false,
        activeUntil: new Date().getTime()
    })

export type EquippedSelection = {
    token: TokenListResponse;
    direction: "long" | "short";
} | null;

export const equippedTokenAtom = atomWithStorage<EquippedSelection>(
    'cfl:equipped-token',
    null,
);